module.exports = __webpack_public_path__ + "media/images/vp/samples/24-452caa14ac2ba2091ea992ebb2dc7b9b.jpg";